import { renameTitle, ChildrenCategories } from "modules/PsyProfile/common/utils"
import {
    getLowestServicePrice,
    getPublicServices,
    psychologistTitles,
} from "utils/helpers/psychologistUtil"
import { Psychologist } from "utils/interfaces"
import { getAvailableLocations } from "utils/helpers"
import { capitalize } from "utils/utils"
import { consultationsByNumeral, numberToYearsInRussian } from "utils/infrastructure/wording-utils"

interface WorkingWithPropsMeta {
    title: string
    check(psy: Psychologist): boolean
}

const workingWithMeta: WorkingWithPropsMeta[] = [
    {
        title: "Взрослые",
        check: (psy) => Boolean(psy.working_with.adults.adults),
    },
    {
        title: "Семьи",
        check: (psy) => Boolean(psy.working_with.family.family),
    },
    {
        title: "Люди в возрасте",
        check: (psy) => Boolean(psy.working_with.adults.elderly),
    },
    {
        title: "Иностранцы",
        check: (psy) => Boolean(psy.working_with.adults.foreigner),
    },
    {
        title: "Верующие",
        check: (psy) => Boolean(psy.working_with.adults.believer),
    },
    {
        title: "Онкопациенты",
        check: (psy) => Boolean(psy.working_with.adults.cancer),
    },
    {
        title: "Феминистки",
        check: (psy) => Boolean(psy.working_with.adults.fem),
    },
]

const workingWithChildrenMeta: WorkingWithPropsMeta[] = [
    {
        title: ChildrenCategories["children_3_10"],
        check: (psy) => Boolean(psy.working_with.children.children_3_10),
    },
    {
        title: ChildrenCategories["children_11_15"],
        check: (psy) => Boolean(psy.working_with.children.children_11_15),
    },
    {
        title: ChildrenCategories["children_16_18"],
        check: (psy) => Boolean(psy.working_with.children.children_16_18),
    },
]

export const headTitle = (psy: Psychologist, showPrice: boolean) => {
    const values: string[] = [`${psy.display_name}, `]

    psychologistTitles(psy).forEach((title) => {
        values.push(`${capitalize(title)}, `)
    })

    values.push(`${psy.new_city.name}`)

    const price = getLowestServicePrice(getPublicServices(psy.offered_services))

    if (price && showPrice) values.push(` – ${price} ₽ за прием`)

    return values.join("")
}

export const headDescription = (psy: Psychologist) => {
    const values: string[] = []
    psychologistTitles(psy).forEach((title, index, array) => {
        const capitalizedTitle = capitalize(title)

        values.push(capitalizedTitle)

        if (index !== array.length - 1) values.push(", ")
    })

    values.push(` ${psy.display_name}: ${psy.new_city.name}`)

    if (psy.city_details) {
        values.push(`, ${psy.city_details}`)
    }

    values.push(` – ${psy.experience} ${numberToYearsInRussian(psy.experience)} опыта.`)

    const availableLocations = getAvailableLocations(psy, false)

    values.push(` 🔥 Принимает ${availableLocations}.`)

    values.push(
        ` Проведено ${psy.booking_count} психологических ${consultationsByNumeral(psy.booking_count)} в Alter.`
    )

    const audience: string[] = []
    workingWithMeta.map(({ title, check }) => {
        if (check(psy)) audience.push(title)
    })
    workingWithChildrenMeta.map(({ title, check }) => {
        if (check(psy)) audience.push(renameTitle(title))
    })

    values.push(` Аудитория – ${audience.join(", ")}.`)

    const psyMethods = psy.methods.map((method) => method.name)

    values.push(`Особенности работы: ${psyMethods.join(", ")}.`)

    return values.join("")
}
